<script>
import { isEmpty, each, get } from 'lodash';
import { STUFF_TO_EAT_KEYS } from 'constants/types';

import NuttremaIconicaKcal from 'components/ui/label/nuttrema-iconica-kcal';
import NuttremaNutritionsStuctureBars from 'components/ui/label/nuttrema-nutritions-stucture-bars';
import ButtonResizeToggler from 'components/ui/button/button-resize-toggler';
import PopoverQuestionAlert from 'components/ui/alert/nuttrema-popover-question-alert';

export default {
  name: 'cmpt-schedule-type-abstract',
  props: {
    schedule: {
      type: Object,
      required: false,
      default: null,
    },
    inComplex: {
      type: Boolean,
      required: false,
      default: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    draggable: {
      type: Boolean,
      required: false,
      default: false,
    },
    permissions: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaIconicaKcal,
    ButtonResizeToggler,
    PopoverQuestionAlert,
    NuttremaNutritionsStuctureBars,
  },
  data() {
    return {
      STUFF_TO_EAT_KEYS,
      activeName: null,
      showRemove: false,
      scheduleType: null,
    };
  },
  methods: {
    getImagePath(item) {
      return !isEmpty(item.EntityImage) ? `${process.env.IMAGES_ROOT}${item.EntityImage.path}${item.EntityImage.thumbnails.medium.filename}` : null;
    },
    changeContent(tab) {
      console.log('tab', tab);
      if (this.activeName === tab) {
        this.activeName = null;
      } else {
        this.activeName = tab;
      }
    },
    toggleShowRemove() {
      this.showRemove = !this.showRemove;
    },
    closeContentHolder() {
      this.activeName = null;
    },
    checkContent(schedule, contents) {
      let size = 0;
      each(contents, (content) => {
        size += isEmpty(get(schedule, content, [])) ? 0 : 1;
      });
      return size > 0;
    },
    handleRemoveScheduleEvent(scheduleID) {
      console.log('handleRemoveScheduleEvent', scheduleID);
      this.$emit('removeSchedule', scheduleID);
    },
    handleEditScheduleEvent(entityType, entityID, scheduleID, scheduleType) {
      console.log('handleEditScheduleEvent', entityType, entityID, scheduleID, scheduleType);
      // update entity type for path
      entityType = this.STUFF_TO_EAT_KEYS[entityType];
      this.$emit('editSchedule', {
        entityType,
        entityID,
        scheduleID,
        scheduleType,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~styles/theme/colors";
  @import "~styles/theme/content-colors";
  @import '~styles/mixins/gradients';

  $default-bg: $element-ui-color-primary;
  $remove-bg: $bg-error-color;
  $remove-text: $text-error-color;
  $edit-text: #607d8b;
  $bg-color: rgba($gray, 0.05);
  $border-color: rgba($gray, 0.15);

  .schedule-item-holder {

    flex-grow: 1;
    display: flex;
    align-self: stretch;
    flex-direction: column;
    margin: 0 0.75em 0 7.75em;

    .schedule-item {
      display: flex;
      flex-shrink: 0;
      position: relative;
      align-self: stretch;
      border-radius: 0.5em;
      justify-content: space-between;
      border: 1px solid $border-color;
      background-color: rgba(255,255,255, 0.85);

      .schedule-item__left, .schedule-item__remove, .schedule-item__edit {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .schedule-item__left {
        display: none;
        transition: all 0.25s linear;
        border-top-left-radius : 0.45em;
        border-bottom-left-radius : 0.45em;
        background-color: rgba($default-bg, 0.25);
        box-shadow:
          // inset  0.5em 0px 0.5em -0.5em rgba(0, 0, 0, 0.25),
          inset -0.5em 0px 0.5em -0.5em rgba(0, 0, 0, 0.35);

        .schedule-item__move {
          display: flex;
          opacity: 0.15;
          padding: 0 0.5em;
          transition: all 0.25s linear;

          &:hover {
            opacity: 1;
            cursor: pointer;
          }

          &.is-disabled {
            opacity: 0;
            &:hover {
              opacity: 0;
              cursor: inherit;
            }
          }
        }
      }

      .schedule-item__remove, .schedule-item__edit {
        display: none;
        padding: 0 0.5em 0 0.75em;
        transition: all 0.25s linear;
        opacity: 0;
        width: 0;
        border-top-right-radius : 0.45em;
        border-bottom-right-radius : 0.45em;
        background-color: rgba($default-bg, 0.35);
        box-shadow:
          inset  0.5em 0px 0.5em -0.5em rgba(0, 0, 0, 0.25);
      }

      .schedule-item__edit {
        > .el-button {
          color: $edit-text;
          &:hover, &:active, &:focus {
            color: darken($edit-text, 10%);
          }
        }
      }

      .schedule-item__remove {
        border-radius: 0;
        background-color: rgba($remove-bg, 0.35);
        width: 1em;
        > * {
          display: none;
        }
        > .el-button {
          color: $remove-text;
          &:hover, &:active, &:focus {
            color: darken($remove-text, 10%);
          }
        }
        &:hover {
          cursor: pointer;
        }
        &.is-open {
          width: inherit;
          > * {
            display: block;
          }
        }
      }

      .schedule-item__central {
        flex-grow: 1;
        display: flex;
        align-self: stretch;
        flex-direction: column;

        .schedule-item__central__main {
          flex-grow: 1;
          display: flex;
          margin: 0.75em 0;
          align-self: stretch;
          justify-content: space-between;

          .schedule-item__text {
            flex-grow: 1;
            display: flex;
            align-self: stretch;
            flex-direction: column;
            justify-content: center;
            .schedule-item--serving-size, .schedule-item--category {
              color: $gray;
              font-size: 0.95rem;
              .serving-size__quantity {
                font-weight: 500;
              }
            }
            .schedule-item---title {
              font-weight: 500;
              line-height: 1.15;
              font-size: 1.15rem;
              margin-bottom: 0.15em;
            }
          }

          .schedule-item__allergens, .schedule-item__kcal, .schedule-item__nutritions-structure {
            display: flex;
            flex-shrink: 0;
            align-items: center;
            margin: 0 0.75em 0 1em;
          }
        }

        .schedule-item__central__content {
          flex-grow: 1;
          display: none;
          align-self: stretch;
          flex-direction: column;

          &.is-closed {
            .central-content-title .content-title-line {
              visibility: hidden;
            }
          }

          .central-content-title {
            display: flex;
            align-self: stretch;
            margin-bottom: -14px;
            align-items: flex-end;
            justify-content: center;

            .content-title-line {
              flex-grow: 1;
              height: 28px;
              position: relative;
              visibility: visible;
              &:before {
                left: 0;
                top: -50%;
                width: 100%;
                content: ' ';
                height: 100%;
                position: absolute;
                display: inline-block;
                border-bottom: 1px solid $border-color;
              }
            }

            .content-title-group {
              height: 28px;
              > .el-radio-group {
                label { float: left; }
              }
              > .el-button-group {
                .el-button:only-child {
                  border-radius: 3px;
                }
              }
            }

          }

          .central-content-holder {
            display: flex;
            align-self: stretch;
            flex-direction: column;
            background-color: rgba($default-bg, 0.05);

            .central-content-holder__content {
              display: flex;
              padding: 1.5em 0 1em;

              .content--text, .exchanges--list {
                padding: 0 0.75em;
              }

              .contents--list {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
              }
            }

            .central-content-holder__close {
              display: flex;
              justify-content: center;
              align-items: center;
              position: relative;
              height: 1em;
            }
          }
        }

      } // end ~ schedule-item__central

      &.have-extra-content {
        margin-bottom: 1.25em;
        > .schedule-item__central {
          > .schedule-item__central__content {
            display: flex;
          }
        }
      }

    } // end ~ schedule-item

    &.is-edit {
      > .schedule-item {
        border-color: rgba($default-bg, 0.35);
        > .schedule-item__left,
        > .schedule-item__remove,
        > .schedule-item__edit {
          opacity: 1;
          display: flex;
          width: inherit;
        }
      }
    }

    &.is-exchnage {
      .schedule-item {
        border-bottom: 1px dotted $border-color !important;
      }
      &:last-child {
        .schedule-item {
          border-bottom: none !important;
        }
      }
    }

    &.is-in-complex {
      margin: 0;
      .schedule-item {
        border-radius: 0;
        border: none;
        border-bottom: 1px solid $border-color;
        background-color: transparent;
        &.have-extra-content {
          margin-bottom: 1em !important;
          border-bottom: 1px solid $border-color !important;
        }
      }
      &:last-child {
        .schedule-item {
          border-bottom: none;
        }
      }
    }

    &:last-child {
      .schedule-item {
        &.have-extra-content {
          margin-bottom: 0.5em;
        }
      }
    }

  } // end ~ schedule-item-holder
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/schedules/list/schedule-type/cmpt-schedule-type-abstract.vue